import { render, staticRenderFns } from "./emergency_treatment3.vue?vue&type=template&id=2da3e524&scoped=true"
import script from "./emergency_treatment3.vue?vue&type=script&lang=js"
export * from "./emergency_treatment3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da3e524",
  null
  
)

export default component.exports